import { useState, useEffect } from 'react';
import { getFiltersFromURL } from '../util.get-filters-from-url.js';

let hasExtractedCategoryFromUrl = false;
function useFilters(menuRootDescriptor, pageDescriptors) {
  const [categoryFilters, setCategoryFilters] = useState([]);
  const [gradeFilters, setGradeFilters] = useState([]);
  useEffect(() => {
    if (menuRootDescriptor === undefined) {
      // don't clear filters when simply closing the mega menu
      return;
    }
    const initialFilters = hasExtractedCategoryFromUrl !== true ? getFiltersFromURL(window.location.search) : undefined;

    // reset state whenever a new MegaMenu is opened, so that filters are not
    // retained across navigation
    setCategoryFilters(initialFilters?.category?.split(",") ?? []);
    setGradeFilters(initialFilters?.grade?.split(",") ?? []);

    // register that we've extracted a filterCategory from the URL
    // automatically (clear it now, so that it doesn't happen again)
    hasExtractedCategoryFromUrl = true;
  }, [menuRootDescriptor, pageDescriptors]);

  // find all matches by category and grade filter, so that we can use the
  // results to generate a combined view
  const availableFilters = extractAvailableFilters(pageDescriptors);
  const matchesByCategory = categoryFilters.length > 0 ? pageDescriptors.filter(it => it.megaMenu.filterCategories?.some(it => categoryFilters.includes(it))) : pageDescriptors;
  const matchesByGrade = gradeFilters.length > 0 ? pageDescriptors.filter(it => it.grades?.some(it => gradeFilters.includes(it))) : pageDescriptors;
  return {
    matchingPageDescriptors: pageDescriptors.filter(it => matchesByCategory.includes(it) && matchesByGrade.includes(it)),
    selectedCategoryFilters: categoryFilters,
    selectedGradeFilters: gradeFilters,
    setCategoryFilters,
    setGradeFilters,
    categoryFilters: availableFilters.category.size > 1 ? [...(menuRootDescriptor?.megaMenu.availableFilterCategories?.filter(categoryFilter => availableFilters.category.has(categoryFilter)).map(categoryFilter => ({
      enabled: gradeFilters.length === 0 || matchesByGrade.find(it => it.megaMenu.filterCategories?.includes(categoryFilter)) !== undefined,
      label: categoryFilter,
      value: categoryFilter
    })) ?? [])] : undefined,
    gradeFilters: availableFilters.grade.size > 1 && menuRootDescriptor?.megaMenu.showGradeFilters ? Array.from(availableFilters.grade).map(gradeFilter => ({
      enabled: categoryFilters.length === 0 || matchesByCategory.find(it => it.grades?.includes(gradeFilter)) !== undefined,
      label: gradeFilter,
      value: gradeFilter,
      sortKey: gradeFilter.replace(/[0-9]+/, value => value.padStart(10, "0"))
    })).toSorted((a, b) => a.sortKey > b.sortKey ? 1 : -1) : undefined
  };
}
function extractAvailableFilters(pageDescriptors) {
  return {
    category: new Set(pageDescriptors.flatMap(it => it.megaMenu.filterCategories).filter(it => it !== undefined)),
    grade: new Set(pageDescriptors.flatMap(it => it.grades).filter(it => it !== undefined))
  };
}

export { useFilters };
//# sourceMappingURL=useFilters.js.map
